import { render, staticRenderFns } from "./LotForm.vue?vue&type=template&id=0c75c0f3&"
import script from "./LotForm.vue?vue&type=script&lang=js&"
export * from "./LotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports